export default __webpack_public_path__ + "static/media/zoom.88bba5f5.png";